module.exports = __webpack_public_path__ + "img/close.37505eef.png";